import { createClient } from '@supabase/supabase-js'

// ─── Supabase Configuration ──────────────────────────────────────────────────
//
// Replace these with your actual Supabase project credentials.
// You can find them at: https://supabase.com/dashboard → Settings → API
//
// For production, use environment variables:
//   VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
//
// In your .env file:
//   VITE_SUPABASE_URL=https://your-project-id.supabase.co
//   VITE_SUPABASE_ANON_KEY=your-anon-key-here
//
// ─────────────────────────────────────────────────────────────────────────────

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://YOUR_PROJECT.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'YOUR_ANON_KEY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
